module.exports = __webpack_public_path__ + "static/media/cap.022719e4.png";